import { Characters } from './unicode.helper';

export const notAvailable = ({ value }) => {
    return value ? value : Characters.EN_DASH;
};
